import { Heading as OriginalHeading } from 'components/v2/Typography/Heading';
import styled from 'styled-components';

export const Wrapper = styled.div<{ $topMargin: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${({ $topMargin }) => $topMargin};
  padding-left: 24px;
  padding-right: 24px;
  max-width: 400px;
  margin: 32px auto;

  @media ${({ theme }) => theme.queries.minTablet} {
    max-width: 480px;
  }
`;

export const Logo = styled.a`
  display: none;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 16px;

  img {
    height: 20px;
    width: auto;
  }

  @media ${({ theme }) => theme.queries.minTablet} {
    display: flex;
  }
`;

export const Heading = styled(OriginalHeading)`
  position: relative;
  text-align: left;
  width: 100%;
  padding: 0 16px;
  margin-top: 0;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    height: 80px;
    background: ${({ theme }) => theme.colors.yellow.primary};
    z-index: -1;
    transform: rotate(-4deg);
    flex-shrink: 0;

    @media ${({ theme }) => theme.queries.minTablet} {
      left: -16px;
    }
  }

  @media ${({ theme }) => theme.queries.minTablet} {
    padding: 0;
  }
`;

export const Description = styled(OriginalHeading).attrs({ tag: 'div', styledAs: 'h5' })`
  padding: 0 16px;

  @media ${({ theme }) => theme.queries.minTablet} {
    padding: 0;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 24px;

  @media ${({ theme }) => theme.queries.minTablet} {
    flex-direction: row;
  }
`;
